<template>
  <div :class="$style[`adl-switch-icon`]">
    <div :class="$style[`adl-switch--leftBelow`]">{{ text }}</div>
    <mds-switch
      :class="classObject"
      v-model="switchValue"
      @change.native="changeValue"
      >{{ label }}
      <mds-button
        variation="icon-only"
        icon="info-circle"
        type="button"
        @mouseover="toggleRangeTT = true"
        @mouseleave="toggleRangeTT = false"
        @focus="toggle = true"
        @blur="toggleRangeTT = false"
        id="default-trigger-range"
        size="small"
      >
      </mds-button>

      <mds-tooltip
        triggered-by="default-trigger-range"
        v-model="toggleRangeTT"
        :position="['bottom-left']"
      >
        <slot v-if="$slots.tooltipText" name="tooltipText"></slot>
        <span v-else>
          {{ tooltipMessage }}
        </span>
      </mds-tooltip>
    </mds-switch>
  </div>
</template>

<script>
import MdsSwitch from "@mds/switch";
import { MdsButton } from "@mds/button";
import MdsTooltip from "@mds/tooltip";

export default {
  name: "AdlSwitchIcon",
  inheritAttrs: false,
  model: {
    prop: "value",
    event: "change",
  },
  components: {
    MdsSwitch,
    MdsButton,
    MdsTooltip,
  },
  data() {
    return {
      toggleRangeTT: false,
    };
  },
  computed: {
    switchValue() {
      return this.value;
    },
    classObject() {
      return this.$style[`adl-switch--${this.position}`];
    },
  },
  props: {
    tooltipMessage: { type: String },
    label: { type: String },
    text: { type: String },
    value: {
      type: Boolean,
    },
    position: String,
  },

  methods: {
    changeValue() {
      this.value = !this.value;
      this.$emit("change", this.value);
    },
  },
};
</script>
<style scoped lang="scss" module>
.adl-switch-icon {
  @import "@mds/constants";
  @import "@mds/typography";
  padding-bottom: $mds-space-2-and-a-half-x;
  .adl-switch--rightBelow {
    position: absolute;
    right: $mds-space-2-x;
  }
  .adl-switch--leftBelow {
    position: absolute;
    right: $mds-space-2-x;
    left: 0px;

    @include mds-body-text-m($bold: true);
  }
}
</style>
